module.exports = __webpack_public_path__ + "templates.product_buy_now_modal-910e719f.html";